import { Box } from "@drone-js/core";
import { partnerMarketingBinder } from "libs/analytics/binders/partnerMarketing";
import { useAnalytics } from "libs/analytics/useAnalytics";
import type { FunctionComponent } from "react";
import { AllYouHaveToDo } from "./AllYouHaveToDo";
import { ContactUs } from "./ContactUs";
import { Faqs } from "./Faqs";
import { FooterBottom } from "./FooterBottom";
import { FooterSiteMap } from "./FooterSiteMap";
import { HeadTag } from "./HeadTag";
import { HeroSection } from "./HeroSection";
import { Navbar } from "./Navbar";
import { WhyAgodaSection } from "./WhyAgodaSection";
import { usePartnerMarketingApi } from "./usePartnerMarketingApi";

export const PartnerMarketingPage: FunctionComponent = () => {
    const { isLoading } = usePartnerMarketingApi();

    useAnalytics(partnerMarketingBinder);

    return (
        <div className="partner-marketing" data-element-name="partner-marketing-container">
            <Box textColor="base.default">
                <Navbar />
                <HeroSection />
                {!isLoading && (
                    <>
                        <HeadTag />
                        <AllYouHaveToDo />
                        <WhyAgodaSection />
                        <Faqs />
                        <ContactUs />
                        <FooterSiteMap />
                        <FooterBottom />
                    </>
                )}
            </Box>
        </div>
    );
};
